// Store opening hours (Europe/Athens). Single source of truth for the
// About page display and the live-chat availability gate.

export type StoreHour = { day: string; time: string };

export const STORE_HOURS: StoreHour[] = [
  { day: "Δευτέρα", time: "10:00–16:00 & 18:00–20:00" },
  { day: "Τρίτη", time: "10:00–16:00" },
  { day: "Τετάρτη", time: "10:00–16:00 & 18:00–20:00" },
  { day: "Πέμπτη", time: "10:00–16:00" },
  { day: "Παρασκευή", time: "10:00–16:00 & 18:00–20:00" },
  { day: "Σάββατο & Κυριακή", time: "Κλειστά" },
];

// Opening intervals per weekday (0 = Sunday ... 6 = Saturday) in minutes from midnight.
const INTERVALS: Record<number, [number, number][]> = {
  1: [[600, 960], [1080, 1200]], // Monday
  2: [[600, 960]], // Tuesday
  3: [[600, 960], [1080, 1200]], // Wednesday
  4: [[600, 960]], // Thursday
  5: [[600, 960], [1080, 1200]], // Friday
  6: [], // Saturday
  0: [], // Sunday
};

/** Returns true if the store is currently open in Europe/Athens time. */
export function isStoreOpen(now: Date = new Date()): boolean {
  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: "Europe/Athens",
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).formatToParts(now);

    const weekdayStr = parts.find((p) => p.type === "weekday")?.value ?? "";
    const hour = Number(parts.find((p) => p.type === "hour")?.value ?? "0");
    const minute = Number(parts.find((p) => p.type === "minute")?.value ?? "0");

    const weekdayMap: Record<string, number> = {
      Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6,
    };
    const weekday = weekdayMap[weekdayStr];
    if (weekday === undefined) return false;

    const minutes = hour * 60 + minute;
    return (INTERVALS[weekday] ?? []).some(([start, end]) => minutes >= start && minutes < end);
  } catch {
    return false;
  }
}
